const C = {
  name: "LegalTeam",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13 2V4H20.7808L23 12.8769V14C23 15.0682 22.5725 16.0817 21.8271 16.8271C21.0805 17.5738 20.0565 18 19 18C17.9435 18 16.9195 17.5738 16.1729 16.8271C15.4262 16.0805 15 15.0565 15 14V12.8769L16.7192 6H13V20H17V22H7V20H11V6H7.28078L9 12.8769V14C9 15.0682 8.5725 16.0817 7.82711 16.8271C7.08045 17.5738 6.05646 18 5 18C3.94354 18 2.91955 17.5738 2.17289 16.8271C1.42624 16.0805 1 15.0565 1 14V12.8769L3.21922 4H11V2H13ZM5.21922 6H4.78078L3.28078 12H6.71922L5.21922 6ZM7 14H3C3 14.5235 3.21376 15.0395 3.58711 15.4129C3.96045 15.7862 4.47646 16 5 16C5.52354 16 6.03955 15.7862 6.41289 15.4129C6.7875 15.0383 7 14.5318 7 14ZM18.7808 6L17.2808 12H20.7192L19.2192 6H18.7808ZM17.5871 15.4129C17.9605 15.7862 18.4765 16 19 16C19.5235 16 20.0395 15.7862 20.4129 15.4129C20.7875 15.0383 21 14.5318 21 14H17C17 14.5235 17.2138 15.0395 17.5871 15.4129Z" fill="currentColor"/>
</svg>
  `
};
export {
  C as LegalTeam
};
